import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { baseUrlForFile, currentUser } from "../helpers";

import { deleteVideo, getVideo, uploadVideo } from "../service/videoUpload";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import ReactLoading from "react-loading";
export default function VideoList() {
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const handleClose = () => {
    setShow(false);
    setFormValues("");
  };
  const handleShow = () => setShow(true);
  const userInfo = currentUser();
  const role = userInfo?.userRole;
  const [expandedDescription, setExpandedDescription] = useState({});
  const [formValues, setFormValues] = useState({
    title: "",
    description: "",
    file: null,
  });
  const [data, setData] = useState([]);
  const { title, description } = formValues;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    setFormValues({
      ...formValues,
      file: e.target.files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { title, description, file } = formValues;

    if (!title || !description || !file) {
      alert("Please fill in all fields and select a file.");
      return;
    }

    const formData = new FormData();
    formData.append("Title", title);
    formData.append("Description", description);
    formData.append("File", file);
    setLoader(true);
    try {
      const response = await uploadVideo(formData);
      getVideoList();
      if (response.status) {
        toast.success(response.message);
        handleClose();
      } else {
        toast.error("SomeThing Went wrong! ");
      }
    } catch (error) {
      toast.error(error.response.data.message ?? "SomeThing Went wrong! ");
    } finally {
      setTimeout(() => {
        setLoader(false);
      }, 3000);
    }
  };




  const getVideoList = async () => {
    try {
      const response = await getVideo();
      setData(response?.data);
    } catch (error) {
   
      console.error("Error fetching video list:", error.response?.data || error.message);
      // toast.error("Failed to fetch video list.");
    }
  };
  useEffect(() => {
    getVideoList();
  }, []);
  const handleDelete = async (id) => {
    try {
      const { isConfirmed } = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });

      if (isConfirmed) {
        const response = await deleteVideo(id);
        console.log(response, "data98985");
        if (response) {
          getVideoList();
          Swal.fire("Deleted!", response.message, "success");
        } else {
          Swal.fire("Error!", "Failed to delete revenue.", "error");
        }
      }
    } catch (error) {
      toast.error("Error submitting form:", error);
    }
  };

  const toggleDescription = (id) => {
    console.log(id, "datta859");
    setExpandedDescription((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div className="custom_container mb-3 ">
      <div className="">
        <div>
          <section id="video">
            <div className="video">
              <div className="row">
                <div className="header-area  d-flex justify-content-between align-items-center pt-3">
                  <div className="main_title">Learning Center</div>

                  <div className="right-head d-flex justify-content-between align-items-center">
                    <div className="list-icon me-3">
                      <i className="fa-solid fa-list"></i>
                    </div>
                    <div className="grid-icon me-3">
                      <i className="fa-solid fa-list"></i>
                    </div>
                  </div>
                  <div>
                    {" "}
                    {role === "SuperAdmin" ? (
                      <button className="videoUploader" onClick={handleShow}>
                        + Upload Video
                      </button>
                    ) : (
                      " "
                    )}
                  </div>
                </div>
              </div>

              <div className="player-area mt-2">
                <div className="row">
                {data?.length > 0 ? (
  data.map((item) => (
    <div className="col-lg-3 col-md-6 col-sm-12 mb-3" key={item.id}>
      <div className="card video-card border-0">
        <div className="card-vid">
          <video width="320" height="215" controls>
            <source
              src={`${baseUrlForFile}/${item.filePath}`}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="card-body video-body">
          <div className="series">{item.title}</div>
          <div>
            <div
              className={`series ${
                expandedDescription[item.id] ? "expanded" : "collapsed"
              }`}
            >
              {item.description}
            </div>
            <button
              className="btn btn-link px-0"
              onClick={() => toggleDescription(item.id)}
            >
              {expandedDescription[item.id] ? "Read Less" : "Read More"}
            </button>
          </div>
        </div>
        {role === "SuperAdmin" ? (
          <div className="card-footer video-footer d-flex justify-content-between align-items-center border-0">
            <div className="publis fw-semibold" hidden>
              <button className="btn btn-dark border-0">Publish</button>
            </div>
            <div className="btn-area d-flex">
              <div
                className="oneye"
                onClick={() => handleDelete(item.id)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  ))
) : (
  <div className="col-12 text-center">
    <span>No Videos Available</span>
  </div>
)}
               
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} centered>
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Upload Video</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Title"
                    name="title"
                    onChange={handleChange}
                    value={title}
                  />
                </Form.Group>
              </Col>
              <Col md="12">
                <Form.Group>
                  <Form.Label>File</Form.Label>
                  <Form.Control type="file" onChange={handleFileChange} />
                </Form.Group>
              </Col>
              <Col md="12">
                <Form.Group>
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    type="text"
                    name="description"
                    placeholder="Description"
                    value={description}
                    onChange={handleChange}
                    className="mb-0"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="success" type="submit">
              Upload
            </Button>
          </Modal.Footer>
        </Form>
        {loader ? (
          <ReactLoading
            type={"bars"}
            color="#33995e"
            height={60}
            width={60}
            className={"globe_loader"}
          />
        ) : (
          ""
        )}
      </Modal>
    </div>
  );
}
